const DeliverySaverPlanTagComponentDefinition = {
    template: require('./delivery-saver-plan-tag.component.html').trim(),
    bindings: {
        tag: '<',
    },
};

module.exports = {
    DeliverySaverPlanTagComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/plantag/delivery-saver-plan-tag.component.js